import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right-circle",
  "use": "icon-chevron-right-circle-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 63 63\" id=\"icon-chevron-right-circle\">\n<path d=\"M28.3,47.2l-5-4.9l10.8-10.8L23.2,20.5l5-5L44,31.4L28.3,47.2z M63,31.5C63,14.1,48.9,0,31.5,0S0,14.1,0,31.5\n\tS14.1,63,31.5,63S63,48.9,63,31.5z M56,31.5C56,45,45,56,31.5,56S7,45,7,31.5C7,18,18,7,31.5,7S56,18,56,31.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-right-circle.svg
// module id = 115
// module chunks = 0 1 2